import {Directive, DirectiveContext} from "@/modules/nf-core";
class VHoverStyleDirective extends DirectiveContext {
    el
    recover
    constructor(directive) {
      super(directive);
      this.onMouseEnterRef = this.onMouseEnter.bind(this);
      this.onMouseLeaveRef = this.onMouseLeave.bind(this);
    }

    bind(el) {
      super.bind(...arguments);
      this.el = el;
      el.addEventListener("mouseenter", this.onMouseEnterRef, false);
      el.addEventListener("mouseleave", this.onMouseLeaveRef, false);
    }
    unbind(el, binding, vnode) {
      super.unbind(...arguments);
      el.removeEventListener('mouseenter', this.onMouseEnterRef, false);
      el.removeEventListener('mouseleave', this.onMouseLeaveRef, false);
    }
    onMouseEnterRef
    onMouseEnter() {
      let modify = this.value;
      if(typeof value === "string") {
        modify = {
          color: modify,
        };
      }
      let original = {};
      for (let key in modify) {
        original[key] = this.el.style[key];
        this.el.style[key] = modify[key];
      }
      this.recover = () => {
        for (let key in original) {
          this.el.style[key] = original[key];
        }
        this.recover = null;
      };
    }
    onMouseLeaveRef
    onMouseLeave() {
      if(this.recover) {
        this.recover();
      }
    }
}

export default function(Vue) {
  new Directive('hover-style').register(VHoverStyleDirective);
}
